import { inject, Service } from '@angular/core';
import { HttpService } from '@data-services/http/http.service';
import { MbeProject } from './mbe-project.model';
import { ImportProjectResponse } from './import-project-response.model';

@Service()
export class MbeProjectDataService {
  private readonly http = inject(HttpService);

  async getMbeProjectsAsync(): Promise<MbeProject[]> {
    return await this.http.getObjectAsync<MbeProject[]>('mbeProjects');
  }

  async importProjectAsync(mbeProject: MbeProject): Promise<ImportProjectResponse> {
    return await this.http.postObjectAsync<MbeProject, ImportProjectResponse>('mbeProjects/import', mbeProject);
  }
}
